import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

const BRANDFETCH_URL = "https://cdn.brandfetch.io/";
const BRANDFETCH_TOKEN = "1idNusMaZuSqfXUE8Lk";
const BRANDFETCH_FALLBACK = `/fallback/404?c=${BRANDFETCH_TOKEN}`;
const FALLBACK_IMAGE_URL = `${URL_ORIGINAL_WEBSITE}/images/footer/assets/uptime-logo.svg`;

export const getImageUrl = (image?: string, domain?: string): string => {
  if (image) {
    if (image.startsWith("http")) {
      if (image.startsWith(BRANDFETCH_URL)) {
        if (image.includes("?c=")) {
          return image.replace(/\?c=.*/, BRANDFETCH_FALLBACK);
        } else {
          return image.replace(/\/$/, "") + BRANDFETCH_FALLBACK;
        }
      } else {
        return image;
      }
    } else {
      return URL_ORIGINAL_WEBSITE + image;
    }
  } else if (domain) {
    return BRANDFETCH_URL + domain + BRANDFETCH_FALLBACK;
  } else {
    return FALLBACK_IMAGE_URL;
  }
};

export const imageRefCallback = (img: HTMLImageElement | null) => {
  if (img) {
    // required to show fallback image above alt text
    img.onerror = () => {
      if (img.src !== FALLBACK_IMAGE_URL) {
        img.src = FALLBACK_IMAGE_URL;
      }
    };
  }
};
